let ExperienciaData = {
    Titulo: "Experiência",
    sub: [
        {
            subtitulo: "Empresa Júnior: Orc'estra Gamificação",
            item: ['Trainee 2021/1-Presente']
        },
        {
            subtitulo: 'Estágio',
            item: ['Administração Central do INSS, Divisão de Gestão de Pessoas']
        },

    ]
}

export default ExperienciaData